module.exports = __webpack_public_path__ + "static/img/inclusive-gateway.523a7d3f.svg";